import { useEffect, useState } from "react";
import { getOfertaById, postOferta, patchOferta } from "../../services/OfertasCabServices";
import { getOfertaDetById, postOfertaDet, patchOfertaDet } from "../../services/OfertasDetServices";
import { OfertasCabFormContext } from "./OfertasCabContext";
import { useNavigate, useParams } from 'react-router-dom';

export const OfertasCabFormState = ({ children }) => {
    const [report, setReport] = useState({});
    const [data, setData] = useState({});

    const { id } = useParams();

    const navigate = useNavigate();
    const [detalleOfertaData, setDetalleOfertaData] = useState([]);

    useEffect(() => {
        if (id) getOfertaByIdData(id);
    }, [id]);

    async function getOfertaByIdData(id) {
        let res = await getOfertaById(id);
        if (res) setReport(res);
    }

    const postOfertaData = async (body) => {
        try {
            // Primero grabamos la oferta cabecera
             const resCab = await postOferta(body);
            // Si hay datos de detalle y la oferta cabecera se grabó correctamente
            if (detalleOfertaData.length > 0 ) {
                const ofertaCabId =resCab.data.id;

                // Actualizamos el array de detalles añadiendo el ofcab_id a cada elemento
                const detalles = detalleOfertaData.map(({ id, descripcion, ...item }) => ({
                    ...item,
                    ofcab_id: ofertaCabId, // Añadir el id de la cabecera
                }));

                // Recorremos cada detalle y lo grabamos uno por uno
                for (const detalleItem of detalles) {
                    await postOfertaDet(detalleItem);  // Aquí se graba cada item
                }
            }

            // Navegamos a la página de ofertas después de que todo se haya grabado
            navigate("/ofertas");

        } catch (error) {
            console.error("Error grabando oferta cabecera o detalles:", error);
        }
    };



    const patchOfertaData = async (id, body) => {
        const resCab = await patchOferta(id, body);
        // Si hay datos de detalle y la oferta cabecera se grabó correctamente
        if (detalleOfertaData.length > 0 ) {
            const ofertaCabId = body.id;

            // Actualizamos el array de detalles añadiendo el ofcab_id a cada elemento
            const detalles = detalleOfertaData.map(({ id, descripcion, ...item }) => ({
                ...item,
                ofcab_id: ofertaCabId, // Añadir el id de la cabecera
            }));

            // Recorremos cada detalle y lo grabamos uno por uno
            for (const detalleItem of detalles) {
                await postOfertaDet(detalleItem);  // Aquí se graba cada item
            }
        }

        navigate("/ofertas");
    };

    const addItemToArray = (item) => {
        setDetalleOfertaData((prevData) => [...prevData, item]);
    };

    const getItemFromArrayById = (id) => {
        // Convertimos ambos a string para asegurarnos de que la comparación sea consistente
        const item = detalleOfertaData.find((item) => String(item.id) === String(id));

        return item || null; // Si no encuentra el elemento, devuelve null
    };


    const updateItemFromArray = (id, updatedFields) => {
        setDetalleOfertaData((prevState) =>
            prevState.map(item =>
                item.id === id
                    ? { ...item, ...updatedFields }
                    : item
            )
        );
    };

    const removeItemFromArray = (id) => {
        setDetalleOfertaData((prevState) =>
            prevState.filter(item => item.id !== id)
        );
    };

    const clearArray = () => {
        setDetalleOfertaData([]); // Establece el estado a un array vacío
    };
    return (
        <OfertasCabFormContext.Provider value={{
            report,
            data,
            postOfertaData,
            patchOfertaData,
            detalleOfertaData,
            addItemToArray,
            getItemFromArrayById,
            updateItemFromArray,
            removeItemFromArray,
            clearArray
        }}>
            {children}
        </OfertasCabFormContext.Provider>
    );
};
